export const transactionTableHeaders = {
  inward: [
    { id: 'id', name: 'Order ID', align: 'center' },
    { id: 'order_date', name: 'Order Date', align: 'center' },
    { id: 'delivery_date', name: 'Delivery Date', align: 'center' },
    { id: 'site_name', name: 'Site Name', align: 'left' },
    { id: 'invoice_number', name: 'Invoice Number', align: 'center' },
    { id: 'quantity', name: 'Fuel Quantity', align: 'center' },
    { id: 'price_per_litre', name: 'Unit Price', align: 'center' },
    { id: 'supplier', name: 'Supplier', align: 'left' },
    { id: 'source', name: 'Source', align: 'center' },
    { id: 'received_tank_name', name: 'Received Tank', align: 'left' },
    {
      id: 'action', disable: true, name: 'Action', align: 'center'
    }
  ],
  iot: [
    { id: 'order_id', name: 'Order ID', align: 'center' },
    { id: 'end_time', name: 'Delivery Time', align: 'center' },
    { id: 'site_name', name: 'Site Name', align: 'center' },
    { id: 'address', name: 'Dispenser Address', align: 'center' },
    { id: 'nozzle_num', name: 'Nozzle Number', align: 'center' },
    { id: 'vehicle_number', name: 'Vehicle Number', align: 'center' },
    { id: 'vehicle_model', name: 'Vehicle Model', align: 'center' },
    { id: 'vehicle_category', name: 'Vehicle Category', align: 'center' },
    { id: 'odometer_entry', name: 'Odometer Reading', align: 'center' },
    { id: 'opening_stock', name: 'Opening Stock', align: 'center' },
    { id: 'closing_stock', name: 'Closing Stock', align: 'center' },
    { id: 'quantity', name: 'Fuel Quantity', align: 'center' },
    {
      id: 'action', disable: true, name: 'Action', align: 'center'
    }
  ],
  transfer: [
    { id: 'order_id', name: 'Order ID', align: 'center' },
    { id: 'end_time', name: 'Delivery Time', align: 'center' },
    { id: 'site_name', name: 'Site Name', align: 'left' },
    { id: 'address', name: 'Dispenser Address', align: 'left' },
    { id: 'nozzle_num', name: 'Nozzle Number', align: 'center' },
    { id: 'card_num_1', name: 'Vehicle Card', align: 'center' },
    { id: 'card_num_2', name: 'Operator Card', align: 'center' },
    { id: 'vehicle_number', name: 'Vehicle Number', align: 'center' },
    { id: 'vehicle_model', name: 'Vehicle Model', align: 'center' },
    { id: 'vehicle_category', name: 'Vehicle Category', align: 'center' },
    { id: 'quantity', name: 'Fuel Quantity', align: 'center' },
    {
      id: 'action', disable: true, name: 'Action', align: 'center'
    }
  ],
  external: [
    { id: 'id', name: 'ID', align: 'center' },
    { id: 'date_time', name: 'Date Time', align: 'center' },
    { id: 'site_name', name: 'Site Name', align: 'left' },
    { id: 'vehicle_number', name: 'Vehicle Number', align: 'center' },
    { id: 'odometer_entry', name: 'Odometer', align: 'center' },
    { id: 'quantity', name: 'Quantity', align: 'center' },
    { id: 'unit_price', name: 'Unit Price', align: 'center' },
    { id: 'amount', name: 'Amount', align: 'center' },
    {
      id: 'action', disable: true, name: 'Action', align: 'center'
    }
  ]
};

export const getAlignByColumnId = (headCells = []) => headCells.reduce((acc, cell) => {
  if (!cell?.id) return acc;
  const align = ['left', 'center', 'right'].includes(cell?.align) ? cell.align : 'left';
  acc[cell.id] = align;
  return acc;
}, {});

export const siteTableHeaders = [
  { id: 'code', name: 'Site Code', align: 'center' },
  { id: 'name', name: 'Site Name', align: 'left' },
  { id: 'city', name: 'Location', align: 'center' },
  { id: 'timezone', name: 'Timezone', align: 'center' },
  { id: 'dispensers_count', name: 'Total Dispensers', align: 'center' },
  { id: 'tanks_count', name: 'Total Tanks', align: 'center' },
  { id: 'vehicle_count', name: 'Total Vehicles', align: 'center' },
  { id: 'operators_count', name: 'Total Operators', align: 'center' },
  { id: 'active', name: 'Status', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'right'
  }
];

export const groupTableHeaders = [
  { id: 'id', name: 'ID', align: 'center' },
  { id: 'name', name: 'Name', align: 'center' },
  {
    id: 'type', name: 'Type', disable: true, align: 'center'
  },
  { id: 'created_at', name: 'Created On', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  }
];

export const tankTableHeaders = [
  { id: 'name', name: 'Tank Name', align: 'left' },
  { id: 'type', name: 'Tank Type', align: 'left' },
  { id: 'dispenser_name', name: 'Dispenser Name', align: 'center' },
  { id: 'current_balance', name: 'Current Volume', align: 'center' },
  { id: 'balance', name: 'Fuel Level', align: 'center' },
  { id: 'automation', name: 'Automaton', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  }
];

export const dispenserTableHeaders = [
  { id: 'station_name', name: 'Dispenser Name', align: 'left' },
  { id: 'address', name: 'Dispenser Address', align: 'center' },
  { id: 'site_name', name: 'Site Name', align: 'left' },
  { id: 'tank_name', name: 'Tank Name', align: 'left' },
  { id: 'mode', name: 'Dispenser Mode', align: 'center' },
  { id: 'article', name: 'Fuel Type', align: 'center' },
  { id: 'status', name: 'Status', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  }
];

export const cardTableHeaders = [
  { id: 'id', name: 'SL No', align: 'center' },
  { id: 'uid', name: 'Card UID', align: 'center' },
  { id: 'vehicle_number', name: 'Vehicle Number', align: 'center' },
  { id: 'site', name: 'Site', align: 'center' },
  { id: 'card_category', name: 'Card Category', align: 'center' },
  { id: 'per_filling_limit', name: 'Per Filling Limit', align: 'center' },
  { id: 'per_day_limit', name: 'Per Day Limit', align: 'center' },
  { id: 'limit_quantity', name: 'Limit Quantity', align: 'center' },
  { id: 'fill_limit_type', name: 'Fill Limit Type', align: 'center' },
  { id: 'active', name: 'Status', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'right'
  }
];

export const vehicleTableHeaders = [
  { id: 'registration_num', name: 'Registration Number', align: 'center' },
  { id: 'model', name: 'Vehicle Model', align: 'center' },
  { id: 'vehicle_group', name: 'Vehicle Group', align: 'center' },
  { id: 'site_name', name: 'Site name', align: 'center' },
  { id: 'asset_code', name: 'Asset code', align: 'center' },
  {
    id: 'type', name: 'Mileage', disable: true, align: 'center'
  },
  { id: 'active', name: 'Status', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  }
];

export const vehicleRecordTableHeaders = [
  { id: 'registration_num', name: 'Vehicle Number', align: 'center' },
  { id: 'shift', name: 'Shift', align: 'center' },
  { id: 'date', name: 'Date', align: 'center' },
  { id: 'opening_reading', name: 'Opening Reading', align: 'center' },
  { id: 'closing_reading', name: 'Closing Reading', align: 'center' },
  { id: 'running_hours', name: 'Running Hours', align: 'center' },
  { id: 'number_of_trips', name: 'Total Trips', align: 'center' },
  {
    id: 'quantity', disable: true, name: 'Quantity', align: 'center'
  },
  {
    id: 'hsd', disable: true, name: 'HSD', align: 'center'
  }
];

export const vehicleUtilizationTableHeaders = [
  { id: 'registration_num', name: 'Registration Number', align: 'center' },
  { id: 'utilisation', name: 'Utilized Hours', align: 'center' },
  { id: 'monthly_fixed_engine_hours', name: 'Monthly Limit', align: 'center' },
  { id: 'range', name: 'Utilized Percentage', align: 'center' },
];

export const vehicleIgnitionTableHeaders = [
  { id: 'registration_num', name: 'Registration Number', align: 'center' },
  { id: 'status', name: 'Vehicle Status', align: 'center' },
];

export const userTableHeaders = [
  {
    id: 'first_name', name: 'User Name', align: 'center', width: '21%', minWidth: 200
  },
  {
    id: 'emp_id', name: 'Employee ID', align: 'center', width: '12%', minWidth: 120
  },
  {
    id: 'mobile_num', name: 'Phone', align: 'center', width: '14%', minWidth: 140
  },
  {
    id: 'city', name: 'Address', align: 'center', width: '23%', minWidth: 220
  },
  {
    id: 'timezone', name: 'Timezone', align: 'center', width: '12%', minWidth: 160
  },
  {
    id: 'is_active', name: 'Status', align: 'center', width: '10%', minWidth: 120
  },
  {
    id: 'action', disable: true, name: 'Action', align: 'center', width: '8%', minWidth: 90
  }
];

export const mileageReportTableHeaders = [
  { id: 'order_id', name: 'Order ID', align: 'center' },
  { id: 'start_time', name: 'Date', align: 'center' },
  { id: 'site_name', name: 'Site Name', align: 'left' },
  { id: 'group_name', name: 'Vehicle Group', align: 'left' },
  { id: 'registration_num', name: 'Vehicle No', align: 'center' },
  { id: 'uid', name: 'UID', align: 'center' },
  { id: 'fuel_type', name: 'Fuel Type', align: 'center' },
  { id: 'odometer_entry', name: 'Odometer entry', align: 'center' },
  { id: 'driven', name: 'Driven', align: 'center' },
  { id: 'quantity', name: 'Quantity', align: 'center' },
  { id: 'mileage', name: 'Mileage', align: 'center' }
];

export const reconciliationReportTableHeaders = [
  { id: 'id', name: 'Order ID', align: 'center' },
  { id: 'station_name', name: 'Dispenser Name', align: 'center' },
  { id: 'site_name', name: 'Site Name', align: 'center' },
  { id: 'date', name: 'Date', align: 'center' },
  { id: 'opening_value', name: 'Opening Stock', align: 'center' },
  { id: 'inward', name: 'Inward', align: 'center' },
  { id: 'transfer', name: 'Transfer', align: 'center' },
  { id: 'sales', name: 'Issued', align: 'center' },
  { id: 'stock', name: 'Closing Stock', align: 'center' },
];

export const cardApprovalTableHeaders = [
  { id: 'id', name: 'SL No', align: 'center' },
  { id: 'card_uid', name: 'Card Number', align: 'center' },
  { id: 'vehicle_registration_number', name: 'Vehicle Number', align: 'center' },
  { id: 'requested_quantity', name: 'Requested Limit', align: 'center' },
  { id: 'requested_on', name: 'Requested Date', align: 'center' },
  { id: 'approved_quantity', name: 'Approved Limit', align: 'center' },
  { id: 'approved_or_rejected_on', name: 'Approved Date', align: 'center' },
  { id: 'filled_quantity', name: 'Filled Limit', align: 'center' },
  { id: 'filled_on', name: 'Filled Date', align: 'center' },
  { id: 'remarks', name: 'Remarks', align: 'center' },
  { id: 'status', name: 'Status', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  },
];

export const vehicleBreakDownTableHeaders = [
  { id: 'id', name: 'SL No', align: 'center' },
  { id: 'vehicle_number', name: 'Vehicle Number', align: 'center' },
  { id: 'type', name: 'Breakdown Type', align: 'center' },
  { id: 'location', name: 'Breakdown Location', align: 'left' },
  { id: 'start_time', name: 'Created On', align: 'center' },
  { id: 'expense', name: 'Repair Cost', align: 'center' },
  { id: 'duration', name: 'Breakdown Duration', align: 'center' },
  {
    id: 'description', name: 'Description', disable: true, align: 'left'
  },
  {
    id: 'remarks', name: 'Remarks', disable: true, align: 'left'
  },
  { id: 'status', name: 'Status', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  }
];

export const sensorTransactionsTableHeaders = [
  { id: 'id', name: 'Order ID', align: 'center' },
  { id: 'vehicle_reg_num', name: 'Vehicle Number', align: 'center' },
  { id: 'filled_time', name: 'Filled Time', align: 'center' },
  { id: 'location', name: 'Location', align: 'left' },
  { id: 'quantity', name: 'Fuel Quantity', align: 'center' },
];

export const vehicleWiseFuelConsumptionTableHeaders = [
  { id: 'si_no', name: 'Si No', align: 'center' },
  { id: 'date', name: 'Date', align: 'center' },
  { id: 'contractor_name', name: 'Contractor Name', align: 'left' },
  { id: 'po_number', name: 'PO Number', align: 'center' },
  { id: 'department', name: 'Department', align: 'left' },
  { id: 'vehicle_type', name: 'Type of Vehicle', align: 'left' },
  { id: 'quantity', name: 'Quantity', align: 'center' },
  { id: 'site', name: 'Site', align: 'left' },
  { id: 'hr_or_odometer_reading', name: 'Hr / Odometer Reading', align: 'center' },
  { id: 'totaliser_reading', name: 'Totaliser Reading', align: 'center' }
];

export const tyreDataTableHeaders = [
  { id: 'tyre_number', name: 'Tyre Number', align: 'center' },
  { id: 'km_travelled', name: 'KM Travelled', align: 'center' },
  { id: 'vehicle_number', name: 'Vehicle Number', align: 'center' },
  { id: 'figment_date', name: 'Figment Date', align: 'center' },
  { id: 'expired', name: 'Active', align: 'center' },
  {
    id: 'action', disable: true, name: 'Action', align: 'center'
  }
];
